import React from "react";
import { Text } from "../Text/Text";
import { Link } from "../Link/Link";
import HTMLReactParser, { domToReact, DOMNode } from "html-react-parser";
import { ThemeUIStyleObject } from "theme-ui";
import { Box } from "../Box/Box";

export const richTextStyles: ThemeUIStyleObject = {
  h3: {},
  ".emphasize": {
    textTransform: "uppercase",
  },
  ".secondary": {
    color: "darkGreen",
  },
  a: {
    color: "darkGreen",
    "&:hover": { textDecoration: "underline" },
  },
  "ul, ol": {
    pl: 5,
  },
  li: {
    maxWidth: "100%",
    marginBottom: 4,
    lineHeight: "normal",
    "ul, ol": {
      marginTop: 4,
    },
  },
  p: {
    "&:last-of-type": {
      mb: 0,
    },
  },
};

export interface ParseHtmlToReactProps {
  html: string;
  sx?: ThemeUIStyleObject;
}

const transform = (node: DOMNode) => {
  if (
    node.type === "tag" &&
    node.name === "span" &&
    node.attribs.class === "emphasize"
  ) {
    return (
      <Text as="span" className="emphasize">
        {domToReact(node.children)}
      </Text>
    );
  }

  if (
    node.type === "tag" &&
    node.name === "span" &&
    node.attribs.class === "secondary"
  ) {
    return (
      <Text as="span" className="secondary">
        {domToReact(node.children)}
      </Text>
    );
  }

  if (node.type === "tag" && node.name === "a")
    return (
      <Link
        to={node.attribs.href}
        {...(node.attribs.target && { target: node.attribs.target })}
        {...node.atrribs}
      >
        {domToReact(node.children)}
      </Link>
    );

  return node;
};
/* TODO: Test html react parsers effect on bundle size when gatsby build i working. Run to test: gatsby build && npm run bundle-analyzer */
const ParseHtmlToReact: React.FC<ParseHtmlToReactProps> = ({ sx, html }) => {
  if (!html) return null;
  return (
    <Box sx={{ ...richTextStyles, ...sx }}>
      {HTMLReactParser(html, {
        replace: (domNode) => transform(domNode),
      })}
    </Box>
  );
};

export default ParseHtmlToReact;
